import { useMainStore } from "../store/main.store";
import i18n from "../i18n";
const { t } = i18n.global;

export const setErrorMessage = (message: string) => {
  setToastMessage(message, "error");
};

export const setSuccessMessage = (message: string) => {
  setToastMessage(message, "success");
};

export const setWarningMessage = (message: string) => {
  setToastMessage(message, "warn");
};

const setToastMessage = (message: string, severity: string) => {
  const store = useMainStore();
  store.toastMessage = { message: message, severity: severity };
};

export const getErrorFromResponse = (error: any) => {
  if (!error.messageFields) return "";
  else return ` ${t(error.messageFields.message)} ${error.messageFields.fields.map((field: any) => t(field.name) + " " + field.value).join(", ")}`;
};
